<template>
  <div>
    <div class="video-bot">
      <div class="video-bot-left">
        <!-- <img v-if="register_reward" class="medal" src="./img/register-gift.png" @click="toShowRegister" alt="注册" />
      <img v-if="invite_reward" class="medal" src="./img/yaoqing02.png" @click="toShowInvite" alt="邀请" />
      <img v-if="first_charge_reward" class="medal" src="./img/shouchong03.png" @click="showCharge" alt="首充" /> -->

        <!-- <div class="gift-activity">
          <img class="medal" src="./img/register-gift.png" @click="toShowRegister" alt="注册" />
          <div>粉丝团</div>
        </div>
        <div class="gift-activity">
          <img class="medal" src="./img/yaoqing02.png" @click="toShowRegister" alt="注册" />
          <div>注册送礼</div>
        </div>
        <div class="gift-activity">
          <img class="medal" src="./img/shouchong03.png" @click="toShowRegister" alt="注册" />
          <div>全新座驾</div>
        </div> -->
        <!-- <div
          class="gift-activity"
          @click="toShowBetList"
          v-if="
            glen > 0 &&
            userInfo.id &&
            userInfo.nick_name != anchor.nick_name &&
            appConfig.quiz_factor & 1
          "
        >
          <img class="medal" src="./img/icon-bet.png" alt="一起鹰选" />
          <div>一起鹰选</div>
        </div> -->
      </div>
      <div class="video-bot-right">
        <div class="gift">
          <div class="arrow-bg" @click="turnLeft">
            <img class="arrow" src="./img/share_arr_left.png" alt />
          </div>
          <div class="plane-gift">
            <div class="gift-list" :style="{ width: listWidth, ...giftStyle }">
              <div
                class="gift-item"
                v-show="item.type !== 2"
                v-for="(item, index) in Object.values(gifts)"
                :key="index"
                @click="sendGift(1, item)"
                @mouseover="showFloat(item, index)"
                @mouseleave="hideFloat"
              >
                <img class="gift-item-img" :src="item.icon" alt />
                <!-- <span v-if="item.userNum" class="gift-num">
                  {{ item.userNum }}
                </span> -->
              </div>
            </div>
          </div>
          <div class="arrow-bg" @click="turnRight">
            <img class="arrow" src="./img/share_arr_right.png" alt />
          </div>
          <div class="gold">
            <div class="gold-item">
              <img :src="require('@/assets/user/diamond.png')" />
              <div>
                {{
                  $bigNumber(userInfo.diamond / 100)
                    ? $bigNumber(userInfo.diamond / 100)
                    : 0
                }}
              </div>
            </div>
            <div class="bar"></div>
            <div class="gold-item">
              <img :src="require('@/assets/user/gold.png')" />
              <div>
                {{
                  $bigNumber(userInfo.gold / 100)
                    ? $bigNumber(userInfo.gold / 100)
                    : 0
                }}
              </div>
            </div>
          </div>

          <!-- <div class="gift-activity" @click="recharge">
            <img src="./img/charge.png" />
            <div>充值</div>
          </div>
          <div class="gift-activity" @click="toLogin" @mouseover="showBackpack" @mouseleave="hideBackpack">
            <img src="./img/backpack.png" />
            <div>背包</div>
          </div>
          <div class="gift-activity" @click="noble">
            <div class="gift-activity">
            <img src="./img/royal.png" />
            <div>贵族</div>
          </div> -->
          <!-- 礼物列表 -->
          <static-float
            v-if="showGiftFloat"
            :index="selectedIndex"
            @show="showFloat"
            @hide="hideFloat"
            @sendGift="sendGift"
            :gift="selectedGift"
            :transformNum="transformNum"
          />
          <!-- 背包 -->
          <BackpackFloat
            v-show="isBackpackShow"
            @show="showBackpack"
            @hide="hideBackpack"
            @sendGift="sendGift"
            @useProps="useProps"
            @reloadBackpack="reloadBackpack"
            :userBackpack="userBackpack"
            :showBackpack="isBackpackShow"
          />
        </div>
      </div>
      <!-- 充值 -->
      <user-recharge ref="rechargeDialog" />
      <!-- 邀请活动 -->
      <invite
        v-if="showInvite"
        :showInvite="showInvite"
        :inviteInfo="inviteInfo"
        @closeInvite="showInvite = false"
        @updateUserBag="getUserBag"
        @showToast="showToast"
      ></invite>
      <!-- 首充弹窗 -->
      <first-charge
        v-if="showFirstCharge"
        :isReceive="first_charge_reward"
        :showFirstCharge="showFirstCharge"
        @closeFirstCharge="showFirstCharge = false"
        @updateUserBag="getUserBag"
        @showToast="showToast"
        @showUserCharge="showUserCharge"
      ></first-charge>
      <RegisterGiftDialog
        v-if="showRegister"
        :visible="showRegister"
        :register_reward="register_reward"
        @closeRegister="showRegister = false"
        @updateUserBag="getUserBag"
        @showToast="showToast"
      ></RegisterGiftDialog>
    </div>

    <NobleDialog
      @reloadBackpack="reloadBackpack"
      :anchor="anchor"
      ref="nobledialog"
    ></NobleDialog>
    <FirstSendGift
      :gift="selectedGift"
      :giftNumber="giftNumberConfirm"
      @sendGiftReal="sendGiftReal"
      ref="firstSendGift"
    ></FirstSendGift>
  </div>
</template>
<script>
import { mapState, mapMutations } from "vuex";
import { post } from "../../util/http";
import StaticFloat from "./liveMatchesTwoStaticFloat";
import BackpackFloat from "./backpack-float";
import UserRecharge from "../user-recharge/user-recharge";
import Invite from "../activity/invite.vue";
import FirstCharge from "../activity/first-charge.vue";
import { splicingImg } from "../../util/mixins";
import NobleDialog from "@/components/dialog/NobleDialog";
import FirstSendGift from "@/components/dialog/FirstSendGift";
export default {
  mixins: [splicingImg],
  components: {
    StaticFloat,
    BackpackFloat,
    UserRecharge,
    Invite,
    FirstCharge,
    NobleDialog,
    FirstSendGift,
  },
  props: {
    detail: {
      type: Object,
      default() {
        return {};
      },
    },
    anchor: {
      type: Object,
      default() {
        return {};
      },
    },
    glen: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      form: {
        name: "",
        code: "",
      },
      payMethodId: 1,
      showGiftFloat: false,
      selectedGift: {}, // 选中的礼物
      selectedIndex: 0,
      transformNum: 0,
      giftTransform: 0,
      first_charge_reward: 0,
      invite_reward: 0,
      register_reward: 0,
      inviteInfo: {},
      showRegister: false,
      showInvite: false,
      showFirstCharge: false,
      registerGiftStatus: false,
      nobleDialogVisible: false,
      isBackpackShow: false,
      timerBackpack: null,
      userBackpack: [],
      giftNumberConfirm: 0,
      giftIdConfirm: 0,
    };
  },
  computed: {
    ...mapState(["userInfo", "gifts", "appConfig"]),
    listWidth() {
      return (Object.keys(this.gifts).length * 55) / 100 + "rem";
    },
    giftStyle() {
      return { transform: `translateX(-${this.giftTransform / 100}rem)` };
    },
  },
  mounted() {
    // console.log("userInfo", this.userInfo);
    // this.getActivity();
    // this.getGiftList([]);
    // if (this.userInfo.id) {
    //   this.getUserBag();
    // } else {
    //   this.getGiftList([]);
    // }
    if (this.userInfo.id) {
      this.getUserBackpack();
    }
    console.log("gifts==========", this.gifts);
  },
  beforeDestroy() {
    if (this.registerTime) {
      clearTimeout(this.registerTime);
    }
  },
  methods: {
    ...mapMutations([
      "changeUserInfo",
      "toggleLogin",
      "changeLoginType",
      "changeGiftList",
      "changeProps",
    ]),
    toLogin() {
      if (!this.userInfo.id) {
        this.toggleLogin();
        return;
      }
    },
    reloadBackpack() {
      this.getUserBackpack();
    },
    getUserBackpack() {
      post({
        url: "/api/live/user_backpack",
        data: { user_id: this.userInfo.id },
      }).then(({ data }) => {
        if (data.status == 0) {
          // console.log(data.data.user_backpack, "data.data.user_backpack@@@@@@@@@@@@@@@@@@");
          this.userBackpack = data.data.user_backpack || [];
          let props = {};
          this.userBackpack.forEach((e) => {
            if (e.gid === 5) {
              props.speaker = e.quantity;
            }
            if (e.gid === 2) {
              props.colorful1 = e.quantity;
            }
            if (e.gid === 3) {
              props.colorful2 = e.quantity;
            }
            if (e.gid === 4) {
              props.colorful3 = e.quantity;
            }
          });
          this.changeProps(props);
        }
      });
    },
    getActivity() {
      post({
        url: "/api/activity/activityRewardList",
        data: { uid: this.userInfo.id || 0 },
      }).then(({ data }) => {
        const {
          first_charge_reward,
          invite1_eward,
          invite2_eward,
          invite3_eward,
          invite_num,
          register_reward,
        } = data.data;
        this.first_charge_reward = first_charge_reward;
        this.invite_reward = invite1_eward;
        this.inviteInfo = {
          invite1_eward,
          invite2_eward,
          invite3_eward,
          invite_num,
        };
        this.register_reward = register_reward;
        if (register_reward) {
          if (register_reward != 3) {
            this.$nextTick(() => {
              this.showRegisterDialog();
            });
          }
        }
      });
    },
    // 注册活动弹窗
    toShowRegister() {
      if (this.userInfo.id) {
        this.showRegister = true;
      } else {
        this.changeLoginType("register");
        this.toggleLogin();
      }
    },
    showRegisterDialog() {
      if (this.registerTime) {
        clearTimeout(this.registerTime);
      }
      if (!this.firstShowRegister) {
        this.registerTime = setTimeout(() => {
          if (!this.showRegister) this.showRegister = true;
          this.firstShowRegister = true;
          this.showRegisterDialog();
        }, 3000);
      } else {
        this.registerTime = setTimeout(() => {
          if (!this.showRegister) this.showRegister = true;
          this.firstShowRegister = false;
          this.showRegisterDialog();
        }, 3600000);
      }
    },
    // 首充活动弹窗
    showCharge() {
      if (this.userInfo.id) {
        this.showFirstCharge = true;
      } else {
        this.toggleLogin();
      }
    },
    showUserCharge() {
      this.showFirstCharge = false;
      // this.$store.commit("pay/rechargeShow", true);
    },
    // 邀请活动
    toShowInvite() {
      if (this.userInfo.id) {
        this.showInvite = true;
      } else {
        this.toggleLogin();
      }
    },
    changeMethods(id) {
      this.payMethodId = id;
    },
    Cmoney(i) {
      let { number } = i;
      this.form.name = number;
    },
    recharge() {
      if (this.userInfo.id) {
        // this.$refs.rechargeDialog.open();
        this.$router.push("/user-center/recharge");
      } else {
        this.toggleLogin();
      }
    },
    noble() {
      this.$refs.nobledialog.open();
    },
    CfirmChanges() {
      if (!this.userInfo.id) {
        this.toggleLogin();
        return;
      }
      post({
        url: "/api/order/send",
        data: { amount: 0, currency: this.form.name, payment_account_id: 0 },
      }).then((res) => {
        console.log(res, "data");
      });
    },

    showFloat(gift, index) {
      clearTimeout(this.timer);
      this.showGiftFloat = true;
      if (!gift) return;
      this.selectedGift = gift;
      this.selectedIndex = index;
    },
    hideFloat() {
      this.timer = setTimeout(() => {
        this.showGiftFloat = false;
      }, 100);
    },
    showBackpack() {
      if (!this.userInfo.id) return;
      clearTimeout(this.timerBackpack);
      this.isBackpackShow = true;
    },
    hideBackpack() {
      this.timerBackpack = setTimeout(() => {
        this.isBackpackShow = false;
      }, 100);
    },

    turnRight() {
      if ((this.transformNum + 1) * 8 >= Object.keys(this.gifts).length) return;
      this.transformNum++;
      this.giftTransform += 433;
      console.log(this.giftTransform, this.transformNum);
    },
    turnLeft() {
      if (this.transformNum === 0) return;
      this.giftTransform -= 433;
      this.transformNum--;
    },
    sendGift(num, gift) {
      console.log(gift, "gift");
      if (!this.userInfo.id) {
        this.toggleLogin();
        return;
      }
      this.selectedGift = gift;
      this.giftNumberConfirm = num;
      this.giftIdConfirm = gift.gid || gift.id;
      let fastSendGift = localStorage.getItem("isFastSendGift");
      if (fastSendGift == "true") {
        this.sendGiftReal();
      } else {
        this.$refs.firstSendGift.open();
      }
    },
    async sendGiftReal() {
      this.showGiftFloat = false;
      if (!this.detail.anchorid) {
        this.$emit("showToast", this.$t("gift-send.not-yet-started"));
        return;
      } else {
        this.$emit(
          "sendGiftInfo",
          this.giftIdConfirm,
          this.giftNumberConfirm,
          this.giftList
        );
      }
    },
    useProps(type, id) {
      this.$emit("usePropsActive", type, id);
    },
    showToast(text) {
      this.$emit("showToast", text);
    },
    toShowBetList() {
      this.$emit("toShowBetList");
    },
  },
};
</script>
<style scoped lang="scss">
.footer_one {
  width: 2.9rem;
  height: 0.4rem;
  margin: 0 auto;
  padding: 0.13rem 1.17rem;
  color: #fff;
  font-size: 0.14rem;
  border-radius: 0.03rem;
  background-image: linear-gradient(to top, #58c0ab, #146c7e);
}
.pay_methods_content {
  width: 100%;
  // height: 269px;
  background-color: #fff;
  box-sizing: border-box;
  margin-top: 0.19rem;
  margin-bottom: 0.2rem;
  .pay_list {
    width: 100%;
    display: flex;
    justify-content: space-around;
    .pay_list_item {
      position: relative;
      display: flex;
      align-items: center;
      padding: 0.14rem 0.2rem;
      box-sizing: border-box;
      border: solid 0.01rem #d5d5d5;
      > img {
        width: 0.25rem;
        margin-right: 0.07rem;
      }
    }
    .pay_list_item:hover {
      box-shadow: 0 0 0 0.02rem #b7d7d2, inset 0 0 0 0.01rem #1c8c7a;
    }
    .active {
      border: solid 0.01rem #1c8c7a;
    }
  }
}
.triangle-bottomright {
  position: absolute;
  bottom: 0;
  right: 0;
  width: 0;
  height: 0;
  border-bottom: 0.26rem solid #1c8c7a;
  border-left: 0.28rem solid transparent;
  > img {
    position: absolute;
    left: -0.15rem;
    bottom: -0.24rem;
    width: 0.13rem;
  }
}
.purchase_list {
  .purchase_text {
    color: #333;
    font-size: 0.14rem;
    font-weight: 600;
    margin-bottom: 0.2rem;
  }

  ul {
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;

    li {
      display: flex;
      cursor: pointer;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      border: solid 0.01rem #d5d5d5;
      background-color: #fff;
      border-radius: 0.03rem;
      width: 23%;
      height: 0.66rem;
      margin-bottom: 0.14rem;
      position: relative;

      .top {
        color: #d9bc88;
        margin-bottom: 0.06rem;
        font-weight: 600;
        display: flex;
        align-items: center;

        .number {
          font-size: 0.22rem;
          margin-right: 0.03rem;
        }

        .text {
          font-size: 0.14rem;
        }
      }

      .bottom {
        font-size: 0.14rem;
        color: #999;
      }
    }

    li:hover {
      box-shadow: 0 0 0 0.02rem #b7d7d2, inset 0 0 0 0.01rem #1c8c7a;
    }
  }
}
.video-bot {
  width: 100%;
  height: 0.6rem;
  display: flex;
  align-items: center;
  // margin: 0.4px 0 35px 0;
  // margin: 0.4px 0 0 0;
  // border-radius: 0 0 8px 8px;
  // box-shadow: 0 3px 6px 0 rgba(0, 0, 0, 0.16);
  background-color: #fff;

  .gift-activity {
    width: 0.6rem;
    height: 0.48rem;
    display: flex;
    flex-direction: column;
    justify-content: space-around;
    align-items: center;
    color: #666;
    cursor: pointer;
    font-size: 0.12rem;
    img {
      width: 0.28rem;
      height: 0.28rem;
      // margin-top: 0.02rem;
    }
  }

  .video-bot-left {
    flex: 1;
    display: flex;
  }
  .video-bot-right {
    // width: 7rem;
    .gift {
      width: 100%;
      height: 0.48rem;
      display: flex;
      position: relative;
      justify-content: flex-end;
      align-items: center;
      box-sizing: border-box;
      .arrow-bg {
        width: 0.24rem;
        height: 0.45rem;
        border-radius: 0.03rem;
        background-color: #eee;
        display: flex;
        justify-content: center;
        align-items: center;
        cursor: pointer;
      }
      .arrow {
        width: 0.24rem;
        height: 0.24rem;
        cursor: pointer;
      }
      .plane-gift {
        display: flex;
        width: 4.33rem;
        overflow: hidden;
        margin: 0 0.04rem;
        .gift-item {
          width: 0.48rem;
          height: 0.48rem;
          margin-right: 0.07rem;
          border-radius: 0.04rem;
          background: #f5f5f7;
          cursor: pointer;
          position: relative;

          &:nth-child(8n) {
            margin-right: 0;
          }
        }

        .gift-num {
          padding: 0.01rem 0.06rem;
          position: absolute;
          top: 0;
          right: 0;
          border-radius: 0 0.04rem 0 0.04rem;
          background: linear-gradient(-45deg, #dcb273, #f0d9ab);
          color: #fff;
          font-family: "Din";
        }

        .gift-item-img {
          width: 100%;
          height: 100%;
          border-radius: 0.04rem;
        }
      }

      .gift-list {
        display: flex;
        justify-content: flex-start;
        align-items: center;
      }
      .gold {
        width: 1.42rem;
        height: 0.48rem;
        background: linear-gradient(
          270deg,
          rgba(78, 238, 204, 0.06) 0%,
          rgba(38, 217, 157, 0.05) 100%
        );
        border-radius: 0.04rem;
        display: flex;
        justify-content: center;
        align-items: center;
        margin-left: 0.2rem;
        margin-right: 0.1rem;
        .bar {
          width: 0.01rem;
          height: 0.24rem;
          background: rgba(2, 168, 162, 0.2);
        }
        .gold-item {
          display: flex;
          flex-direction: column;
          justify-content: space-around;
          align-items: center;
          flex: 1;
        }
        img {
          width: 0.25rem;
          height: 0.25rem;
          margin-bottom: 0.05rem;
        }
      }
    }
    .balance {
      height: 0.3rem;
      width: 100%;
      display: flex;
      justify-content: flex-end;
      margin-top: 0.1rem;
      align-items: center;

      .balance-icon {
        width: 0.16rem;
        height: 0.16rem;
      }

      .balance-unit {
        font-size: 0.14rem;
        line-height: 0.2rem;
        color: #666666;
        margin-left: 0.08rem;
      }

      .balance-nums {
        font-size: 0.2rem;
        line-height: 0.24rem;
        color: #333333;
        font-weight: 500;
        margin-left: 0.08rem;
      }
      .balance-click {
        width: 0.64rem;
        height: 0.24rem;
        background: #26d99d;
        border-radius: 0.12rem;
        margin: 0 0.16rem;
        font-size: 0.14rem;
        color: #ffffff;
        text-align: center;
        line-height: 0.24rem;
        cursor: pointer;
      }
    }
  }
}
.gift-down {
  height: 0.4rem;
  background-color: #fff;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  color: #666;
  padding-right: 0.06rem;
  img {
    width: 0.2rem;
    height: 0.2rem;
    margin: 0 0.05rem;
  }
  .num {
    color: #02a8a2;
    margin-right: 0.1rem;
    margin-left: 0.04rem;
  }
}
</style>
